import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { SuccessCircleAltIcon } from '@pattern-library/icon';
import Result from './Result';
var propTypes = {
  /**
   * A button or link
   */
  button: PropTypes.node,
  /**
   * Unformatted content
   */
  children: PropTypes.element,
  /**
   * Heading level of the title
   */
  headingLevel: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  /**
   * The component's title
   */
  title: PropTypes.string,
  /**
   * content below the title
   */
  message: PropTypes.node,
  /**
   * Smaller format layout
   */
  smallLayout: PropTypes.bool
};
var defaultProps = {
  smallLayout: false
};
export function Success(props) {
  return /*#__PURE__*/React.createElement(Result, _extends({
    icon: /*#__PURE__*/React.createElement(SuccessCircleAltIcon, {
      color: "success"
    })
  }, props));
}
Success.propTypes = propTypes;
Success.defaultProps = defaultProps;
export default Success;